import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "isExpanded"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { Box, Text } from '@miro-site/core';
import { Expand } from '../icons/Icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Header = function Header(_ref) {
  var children = _ref.children,
      isExpanded = _ref.isExpanded,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(HeaderStyled, _objectSpread(_objectSpread({
    $variant: "p0",
    as: "div"
  }, props), {}, {
    children: [children, /*#__PURE__*/_jsx(Icon, {
      $isExpanded: isExpanded,
      children: /*#__PURE__*/_jsx(Expand, {})
    })]
  }));
};

var Icon = styled(Box).withConfig({
  displayName: "Header__Icon",
  componentId: "sc-bpcs7k-0"
})(["transition:transform 0.2s ease-in-out;transform:", ";"], function (props) {
  return props.$isExpanded ? 'rotate(180deg)' : 'rotate(0deg)';
});
var HeaderStyled = styled(Text).attrs({
  $variant: 'p1',
  $styles: {
    height: [84, null, null, null]
  }
}).withConfig({
  displayName: "Header__HeaderStyled",
  componentId: "sc-bpcs7k-1"
})(["display:flex;justify-content:space-between;align-items:center;cursor:pointer;user-select:none;"]);
export default Header;